import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'anf-core-react';
import OrderConfirmationContext from '../../../context/OrderConfirmationContext';
import Tmnt from '../../Tmnt/Tmnt';
import $document from '../../../tools/document';

/**
 * This component is displayed to users who have completed a purchase but are not
 * logged in. It utilizes the user's email from the order and prompts them to
 * join My Abercrombie.
 */
export default function CreateAccount({
  email,
  buttonSubmitLabel,
}) {
  const { orderConfirmationData } = useContext(OrderConfirmationContext);
  const { textFor } = orderConfirmationData;
  const { emailLabel } = textFor;

  const handleJoinClick = (event) => {
    event.preventDefault();
    // Dispatch the custom event
    const customEvent = new CustomEvent('authentication-modal:open', {
      detail: { isSignIn: false, email },
    });
    $document.dispatchEvent(customEvent);
  };

  return (
    <div className="ocn-create-account" data-test-id="create-account">
      <div className="ocn-create-account-form__email">
        <label htmlFor="user-email">
          <Tmnt isHtml tmnt={emailLabel.label} />
          {`: ${email}`}
        </label>
      </div>
      <Button
        variant="secondary"
        type="button"
        isFullWidth
        classList="ds-override create-account-button"
        onClick={handleJoinClick}
      >
        <span><Tmnt tmnt={buttonSubmitLabel} /></span>
      </Button>
    </div>
  );
}

CreateAccount.propTypes = {
  email: PropTypes.string.isRequired,
  buttonSubmitLabel: PropTypes.shape({ key: PropTypes.string, value: PropTypes.string })
    .isRequired,
};
